import createLogger from '../../helpers/log';

const logging = createLogger('PublisherStatsSender');

const MAX_BITRATE_BITS_PER_SECOND = 10_000_000; // 10Mbps

const findStatsWithAvailableOutgoingBitrate = (stats = []) =>
  stats.find(({ availableOutgoingBitrate }) => availableOutgoingBitrate !== undefined);

const getSentEstimatedBandwidthBitsPerSecond = stats =>
  findStatsWithAvailableOutgoingBitrate(stats)?.availableOutgoingBitrate;

function PublisherStatsSender(deps = {}) {
  const { streamId } = deps;
  let { socket } = deps;

  if (!socket || !streamId) {
    throw new Error('PublisherStatsSender requires socket and streamId');
  }

  const intervalIds = {};

  const sendStats = (peerConnection, subscriberId) => {
    peerConnection.getStats((error, stats) => {
      if (error || !stats) {
        return;
      }
      const sentEstimatedBandwidthBitsPerSecond = getSentEstimatedBandwidthBitsPerSecond(stats);
      if (!sentEstimatedBandwidthBitsPerSecond) {
        return;
      }
      socket.streamChannelSendData(streamId, 'downlinkStats1', {
        maxBitrateBitsPerSecond: MAX_BITRATE_BITS_PER_SECOND, // 10Mbps as a placeholder
        sentEstimatedBandwidthBitsPerSecond:
          Math.min(sentEstimatedBandwidthBitsPerSecond, MAX_BITRATE_BITS_PER_SECOND),
        sourceStreamId: 'P2P',
        subscriberId,
        timestamp: Date.now(),
      });
    });
  };

  this.addSubscriber = (subscriberId, peerConnection) => {
    if (!subscriberId || !peerConnection) {
      logging.error('PublisherStatsSender requires subscriberId and peerConnection');
      return;
    }
    if (!peerConnection._isP2p()) {
      return;
    }
    this.removeSubscriber(subscriberId);
    intervalIds[subscriberId] = setInterval(() => {
      sendStats(peerConnection, subscriberId);
    }, 1000);
  };

  this.removeSubscriber = (subscriberId) => {
    clearInterval(intervalIds[subscriberId]);
    delete intervalIds[subscriberId];
  };

  this.setSocket = (newSocket) => {
    if (!newSocket) {
      logging.error('PublisherStatsSender requires a valid socket');
      return;
    }
    socket = newSocket;
  };

  this.destroy = () => {
    Object.keys(intervalIds).forEach((subscriberId) => {
      this.removeSubscriber(subscriberId);
    });
  };
}

export default PublisherStatsSender;
